import React from "react";
import { Box, Typography } from "@mui/material";
import { ImageAndTextStyles } from "./ImageAndTextStyles";
import { LOGO } from "../../constants";
import { SxProps, Theme } from "@mui/system";

interface ImageAndTextProps {
  image: string | null | React.ReactNode;
  text: string;
  additionalClassName?: SxProps<Theme>;
  primary?: boolean;
  imageClassName?: SxProps<Theme>;
  hoverElementClass?: SxProps<Theme>;
  additionalClassText?: SxProps<Theme>;
  hoverElement?: boolean;
  type?: string;
  onClick?: () => void;
  onhandleClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const ImageAndText: React.FC<ImageAndTextProps> = ({
  image,
  text,
  additionalClassName,
  primary = false,
  imageClassName,
  additionalClassText,
  type,
  onClick,
  onhandleClick,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (onhandleClick) onhandleClick(event);
    if (onClick) onClick();
  };

  const getStatusStyle = () => {
    if (type !== "overviewTable") return {};

    switch (text) {
      case "Active":
        return { color: "green" };
      case "Cancelled":
        return { color: "red" };
      case "Renewal In Progress":
        return { color: "orange" };
      default:
        return {};
    }
  };

  const statusStyle = getStatusStyle();
  const imageFilter =
    type === "overviewTable"
      ? text === "Active"
        ? "invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)" // green filter
        : text === "Cancelled"
        ? "invert(27%) sepia(51%) saturate(7074%) hue-rotate(356deg) brightness(97%) contrast(119%)" // red filter
        : text === "Renewal In Progress"
        ? "invert(71%) sepia(89%) saturate(1375%) hue-rotate(359deg) brightness(103%) contrast(106%)"
        : ""
      : "";

  return (
    <Box
      id={`${text}-container`}
      data-test-id={`${text}-container`}
      aria-label={`${text} container`}
      sx={Object.assign(
        {},
        ImageAndTextStyles.container,
        additionalClassName,
        primary && ImageAndTextStyles.primaryClassName
      )}
      onClick={handleClick}
    >
      <Box
        id={`${text}-image-container`}
        data-test-id={`${text}-image-container`}
        aria-label={`${text} image`}
        sx={Object.assign(
          {},
          ImageAndTextStyles.image,
          imageClassName,
          statusStyle
        )}
      >
        {typeof image === "string" ? (
          <img
            id={`${text}-image`}
            data-test-id={`${text}-image`}
            aria-label={`${text} image`}
            src={image}
            alt="LOGO"
            style={imageFilter ? { filter: imageFilter } : {}}
          />
        ) : (
          image
        )}
      </Box>
      <Typography
        id={`${text}-text`}
        data-test-id={`${text}-text`}
        aria-label={`${text} text`}
        sx={Object.assign(
          {},
          ImageAndTextStyles.text,
          additionalClassText,
          statusStyle
        )}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default ImageAndText;
